export default {
  'welcome.header.greeting': '👋 你好, {name}',
  'welcome.header.title': '你的 AI 能跑了，现在上线吧。',
  'welcome.header.subtitle':
    '聊天机器人、AI 助手、智能 Agent——从 Demo 到生产，几分钟搞定。',
  'welcome.card.blank.title': '从零开始',
  'welcome.card.blank.desc': '从空白画布开始，完全掌控',
  'welcome.card.template.title': '浏览模板',
  'welcome.card.template.desc': '使用预构建逻辑快速启动项目',
  'welcome.copilot.placeholder': '你在想什么？告诉 Copilot 开始编织...',
  'welcome.apps.title': '探索精选智能体',
  'welcome.apps.minecraft': 'Minecraft 智能体',
  'welcome.apps.tags.react': 'React',
  'welcome.apps.tags.roleplay': '角色扮演',
};
